// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"e9923637","439":"f4c52750","571":"7cc43187","847":"1c4f99b3","865":"9f4ea29c","978":"c49c0bea"}[chunkId] + ".chunk.js";
};